/* import __COLOCATED_TEMPLATE__ from './template-card.hbs'; */
/* RESPONSIBLE TEAM: team-actions */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';

type Args = {
  template: any;
  inEmptyState?: boolean;
  grayScale?: boolean;
  useGradient?: boolean;
  isEmptyState?: boolean;
  onClick: () => void;
};

export default class TemplateCard extends Component<{ Element: HTMLDivElement; Args: Args }> {
  @service declare intercomEventService: any;
  @service declare intl: IntlService;

  get grayScale(): boolean {
    return this.args.grayScale || false;
  }

  get templateKey(): boolean {
    return this.args.template.title.toLowerCase().replace(/\s+/g, '-');
  }

  get title(): string {
    return this.intl.t(`outbound.new-content-modal.task.template-card.${this.templateKey}.title`);
  }

  get description(): string {
    return this.intl.t(
      `outbound.new-content-modal.task.template-card.${this.templateKey}.description`,
    );
  }

  @action
  onClick() {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: `template_card_preview`,
      place: 'task_list',
      section: this.args.inEmptyState ? 'empty_state' : 'template_selector',
      template_id: this.args.template.id,
    });
    this.args.onClick();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Outbound::NewContentModal::TaskTemplate::TemplateCard': typeof TemplateCard;
  }
}
